import { useMemo } from 'react';

import { useApplicationContext } from '../../utils/withApplicationContext';
import { useIsRealtor } from '../useIsRealtor';

/**
 * Баннер "Циан.Ипотека для профи" может быть показан?
 */
export const useIsMortgageBrokerBannerAvailable = (): boolean => {
  const { config } = useApplicationContext();
  const isRealtor = useIsRealtor();

  const isBannerEnabled = !!config.get<boolean>('Transaction.MortgageBrokerMainBannerInObjectCard.Enabled');

  return useMemo(() => Boolean(isBannerEnabled && isRealtor), [isBannerEnabled, isRealtor]);
};
